export default __webpack_public_path__ + "static/media/chart.c4e93d48.svg";